<template>
  <ErrorPageLayout class="error-404">
    <template #heading>
      <AppHeading tag="h1" text="¡Ups!" />
      <p>
        {{ $t('ui.error_page.not_found') }}
        <span class="resource">
          {{ resource }}
        </span>
        {{ $t('ui.error_page.end') }}
      </p>
    </template>
    <template #details>
      <!-- <AppLink text="Volver atrás" @click.native.prevent="backLink" /> -->
      <AppRouterLink
        exact
        :to="backRoute ? backRoute : fallbackRoute"
        :text="$t('ui.generals.go_back_link')"
      />
    </template>
    <template #image>
      <img :src="imageFile" />
    </template>
  </ErrorPageLayout>
</template>

<script>
// Utilities
import notFoundImage from 'Images/components/not-found2.jpeg'
// Components
import AppHeading from 'Ui/AppHeading'
import AppRouterLink from 'Ui/AppRouterLink'
import ErrorPageLayout from 'Layouts/ErrorPageLayout'

export default {
  name: 'NotFound',

  components: {
    AppHeading,
    AppRouterLink,
    ErrorPageLayout,
  },

  props: {
    resource: {
      type: String,
      default() {
        return this.$t('ui.error_page.resource.page')
      },
    },
  },

  data() {
    return {
      backRoute: null,
      fallbackRoute: { name: 'dashboard' },
    }
  },

  computed: {
    imageFile() {
      return notFoundImage
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // If from route have no name, means that the user hit the URL
      // in the browser bar, not coming from an inside link. In that case,
      // we'll rely on the fallbackRoute.
      if (from.name) {
        const totalNestedRoutes = from.matched.length
        const initialCount = totalNestedRoutes - 1

        // going back into the matches routes, e.g: dashboard <- dashboard-team <- card-modal ( hitted route)
        for (let i = initialCount; i >= 0; i--) {
          const backRoute = from.matched[i]
          // if the not found was a modal page or 404 page, we dont want to fall back
          // into a modal page or the not founded route
          if (!backRoute.name?.includes('modal') && backRoute.name !== '404-resource') {
            // console.log('backroute: ', backRoute)
            backRoute.params = from.params // e.g: dashboard-team slected cause card-modal was a not found in the first place

            // accessing trough vm cause component isn't loaded yet
            // setting the "back" link route ⤵
            return (vm.$data.backRoute = backRoute)
          }
        }
      }
      next()
    })
  },
}
</script>

<style scoped>
.error-page__header .app-heading {
  font-weight: 900;
  margin-bottom: 20px;
}

.error-page__wrapper {
  text-align: center;
}

.error-page__content {
  margin-top: 20px;
}

.resource {
  font-weight: 700;
  color: var(--c-secondary-700);
}

.error-404 .error-page__image img {
  max-width: 600px;
}

.app-link {
  text-decoration: underline;
}
</style>
